module.exports = __webpack_public_path__ + "static/media/kiki.b7674fe7.jpg";